/**
 * Lenis smooth scroll for #smooth-wrapper + GSAP ScrollTrigger sync.
 * Lenis loads from the scrolling-borders section only when border art is active for this URL.
 */
(function () {
  var lenisLerp = 0.12;
  var runtime = {
    wrapper: null,
    lenis: null,
    onLenisKeydown: null,
    tickerFn: null,
    refreshInitFn: null,
    resizeFn: null,
    bootstrapped: false
  };

  function refreshScrollTrigger() {
    if (typeof ScrollTrigger !== "undefined") {
      ScrollTrigger.refresh();
    }
  }

  function prefersReduced() {
    return (
      typeof window.matchMedia === "function" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    );
  }

  function shouldIgnoreKeyboardScrollTarget(target) {
    if (!target || target.nodeType !== Node.ELEMENT_NODE) return false;
    if (!target.closest) return false;
    if (
      target.closest(
        "iframe, [contenteditable='true'], [contenteditable='plaintext-only']"
      )
    ) {
      return true;
    }
    var control = target.closest(
      "input, textarea, select, option, [role='combobox'], [role='textbox'], [role='searchbox'], [role='spinbutton'], [role='slider'], [role='listbox']"
    );
    if (control) {
      if (control.tagName === "INPUT") {
        var type = (control.type || "").toLowerCase();
        if (
          type === "checkbox" ||
          type === "radio" ||
          type === "button" ||
          type === "submit" ||
          type === "reset" ||
          type === "file" ||
          type === "hidden"
        ) {
          return true;
        }
      }
      return true;
    }
    return false;
  }

  function bindLenisKeydown(wrapper, lenis) {
    return function onLenisKeydown(e) {
      if (e.defaultPrevented) return;
      if (e.ctrlKey || e.metaKey || e.altKey) return;
      if (lenis.isStopped || lenis.isLocked) return;

      var code = e.code;
      if (
        code !== "ArrowUp" &&
        code !== "ArrowDown" &&
        code !== "PageUp" &&
        code !== "PageDown" &&
        code !== "Home" &&
        code !== "End" &&
        code !== "Space"
      ) {
        return;
      }

      if (shouldIgnoreKeyboardScrollTarget(e.target)) return;

      if (
        code === "Space" &&
        e.target.closest &&
        e.target.closest(
          "button, [role='button'], summary, a[href], input, select, textarea"
        )
      ) {
        return;
      }

      var clientH = wrapper.clientHeight;
      var line = Math.round(Math.max(48, clientH * 0.065));
      var page = Math.round(clientH * 0.925);
      var delta = 0;

      if (code === "ArrowDown") delta = line;
      else if (code === "ArrowUp") delta = -line;
      else if (code === "PageDown") delta = page;
      else if (code === "PageUp") delta = -page;
      else if (code === "Space") delta = e.shiftKey ? -page : page;
      else if (code === "Home") {
        e.preventDefault();
        lenis.scrollTo(0, { programmatic: false, lerp: lenisLerp });
        return;
      } else if (code === "End") {
        e.preventDefault();
        lenis.scrollTo(lenis.limit, { programmatic: false, lerp: lenisLerp });
        return;
      }

      var next = lenis.targetScroll + delta;
      next = Math.max(0, Math.min(lenis.limit, next));
      if (next === lenis.targetScroll) return;

      e.preventDefault();
      lenis.scrollTo(next, { programmatic: false, lerp: lenisLerp });
    };
  }

  window.svDestroyLenisSmoothScroll = function () {
    var wrapper = runtime.wrapper;
    var lenis = runtime.lenis || window.lenis;

    if (runtime.onLenisKeydown) {
      window.removeEventListener("keydown", runtime.onLenisKeydown, false);
      runtime.onLenisKeydown = null;
    }

    if (runtime.tickerFn && typeof gsap !== "undefined") {
      gsap.ticker.remove(runtime.tickerFn);
      runtime.tickerFn = null;
    }

    if (
      runtime.refreshInitFn &&
      typeof ScrollTrigger !== "undefined" &&
      typeof ScrollTrigger.removeEventListener === "function"
    ) {
      ScrollTrigger.removeEventListener("refreshInit", runtime.refreshInitFn);
      runtime.refreshInitFn = null;
    }

    if (runtime.resizeFn) {
      window.removeEventListener("resize", runtime.resizeFn);
      runtime.resizeFn = null;
    }

    if (lenis) {
      if (typeof lenis.destroy === "function") {
        lenis.destroy();
      }
      window.lenis = null;
      runtime.lenis = null;
    }

    if (wrapper && typeof ScrollTrigger !== "undefined") {
      ScrollTrigger.scrollerProxy(wrapper, null);
    }

    document.documentElement.classList.remove(
      "lenis",
      "lenis-smooth",
      "sv-lenis-active"
    );

    runtime.wrapper = null;
    runtime.bootstrapped = false;
    refreshScrollTrigger();
  };

  window.svInitLenisSmoothScroll = function () {
    if (typeof ScrollTrigger === "undefined") {
      return false;
    }

    var wrapper = document.querySelector("#smooth-wrapper");
    var content = document.querySelector("#smooth-content");

    if (!wrapper || !content || prefersReduced()) {
      return false;
    }

    if (typeof window.Lenis === "undefined" || typeof gsap === "undefined") {
      return false;
    }

    if (window.lenis) {
      window.lenis.resize();
      window.lenis.scrollTo(0, { immediate: true });
      refreshScrollTrigger();
      return true;
    }

    document.documentElement.classList.add(
      "lenis",
      "lenis-smooth",
      "sv-lenis-active"
    );

    var lenis = new window.Lenis({
      wrapper: wrapper,
      content: content,
      smoothWheel: true,
      syncTouch: true,
      lerp: lenisLerp
    });

    window.lenis = lenis;
    runtime.wrapper = wrapper;
    runtime.lenis = lenis;

    runtime.onLenisKeydown = bindLenisKeydown(wrapper, lenis);
    window.addEventListener("keydown", runtime.onLenisKeydown, false);

    lenis.on("scroll", ScrollTrigger.update);

    runtime.tickerFn = function (time) {
      lenis.raf(time * 1000);
    };
    gsap.ticker.add(runtime.tickerFn);
    gsap.ticker.lagSmoothing(0);

    ScrollTrigger.scrollerProxy(wrapper, {
      scrollTop: function (value) {
        if (arguments.length) {
          lenis.scrollTo(value, { immediate: true });
        }
        return lenis.scroll;
      },
      getBoundingClientRect: function () {
        return wrapper.getBoundingClientRect();
      },
      pinType: wrapper.style.transform ? "transform" : "fixed"
    });

    runtime.refreshInitFn = function () {
      lenis.resize();
    };
    if (typeof ScrollTrigger.addEventListener === "function") {
      ScrollTrigger.addEventListener("refreshInit", runtime.refreshInitFn);
    }

    runtime.resizeFn = function () {
      lenis.resize();
      refreshScrollTrigger();
    };
    window.addEventListener("resize", runtime.resizeFn);

    lenis.resize();
    refreshScrollTrigger();
    runtime.bootstrapped = true;
    return true;
  };

  function setupPassiveRefresh() {
    if (document.readyState === "complete") {
      refreshScrollTrigger();
    } else {
      window.addEventListener("load", refreshScrollTrigger);
    }
    window.addEventListener("resize", refreshScrollTrigger);
  }

  if (typeof ScrollTrigger === "undefined") {
    return;
  }

  var wrapper = document.querySelector("#smooth-wrapper");
  var content = document.querySelector("#smooth-content");

  if (!wrapper || !content || prefersReduced()) {
    setupPassiveRefresh();
    return;
  }

  if (typeof window.Lenis === "undefined" || typeof gsap === "undefined") {
    setupPassiveRefresh();
    return;
  }

  window.svInitLenisSmoothScroll();
})();
